import script from "./ResponseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponseCard.vue?vue&type=script&setup=true&lang=js"

import "./ResponseCard.vue?vue&type=style&index=0&id=33b31689&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b31689"]])

export default __exports__